import Storage from '../../Utility/site-cookies'

const call = (pdfCanvasSelector, articleTextElementSelector) => {
    return {
        pdfUrl: '',
        preferredTranslation: '',

        async start() {
            this.preferredTranslation = Storage().readPref('translation', '');
            await this.replaceLinkTranslationsWithPreferred();

            if (document.querySelector(pdfCanvasSelector)) {
                const val = document.querySelector(pdfCanvasSelector).dataset.content;

                if (val && val.length > 0) {
                    this.pdfUrl = document.querySelector(pdfCanvasSelector).dataset.content;
                }
            }
        },

        async replaceLinkTranslationsWithPreferred() {
            const articleTextElement = document.querySelector(articleTextElementSelector);

            if (!articleTextElement) {
                return;
            }

            const anchorLinks = articleTextElement.querySelectorAll('a');

            if (anchorLinks && anchorLinks.length > 0) {
                for (let i = 0; i < anchorLinks.length; i++) {
                    if (this.preferredTranslation !== 'niv') {
                        anchorLinks[i].href = anchorLinks[i].href.replaceAll('niv/', this.preferredTranslation + '/');
                    } else {
                        anchorLinks[i].href = anchorLinks[i].href.replaceAll('niv/', '');
                    }
                }
            }
        }
    };
};

export default call;